import { render, staticRenderFns } from "./m-common-birthdays-dropdown.vue?vue&type=template&id=c569188a&scoped=true&"
import script from "./m-common-birthdays-dropdown.vue?vue&type=script&lang=js&"
export * from "./m-common-birthdays-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./m-common-birthdays-dropdown.vue?vue&type=style&index=0&id=c569188a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c569188a",
  null
  
)

export default component.exports